"use client"

import { useState } from "react"
import { Button } from "@/components/ui/button"
import { loginUrl } from "@/lib/breach/cloud"
import { useAccount } from "./account"

const KEY = "aab.nudge.dismissed"
const dismissed = () => { try { return window.sessionStorage.getItem(KEY) === "1" } catch { return false } }

/**
 * Recommends signing in. Appears only where sign-in is available and the person is signed out.
 * Invites are not built yet, so that benefit is labelled "coming soon" rather than promised.
 */
export function SignInNudge({ next = "/incident", className }: { next?: string; className?: string }) {
  const { me } = useAccount()
  const [hidden, setHidden] = useState(dismissed)
  if (!me?.configured || me.user || hidden) return null
  return (
    <aside aria-label="Sign in to save your incident" className={`rounded-lg border border-border bg-card p-4 print:hidden ${className ?? ""}`}>
      <p className="font-semibold">Sign in with Google to keep this safe</p>
      <ul className="mt-2 list-disc pl-5 text-sm text-muted-foreground">
        <li>Save your incident to your account, not just this browser</li>
        <li>Pick it up on another computer or phone</li>
        <li>Soon: invite colleagues to help with the response and tick off their own tasks</li>
      </ul>
      <div className="mt-3 flex flex-wrap gap-2">
        <Button asChild size="sm"><a href={loginUrl(next)}>Sign in with Google</a></Button>
        <Button size="sm" variant="ghost" onClick={() => { try { window.sessionStorage.setItem(KEY, "1") } catch { /* ignore */ } setHidden(true) }}>Not now</Button>
      </div>
      <p className="mt-2 text-xs text-muted-foreground">Optional. The tool works without it.</p>
    </aside>
  )
}
